import { render, staticRenderFns } from "./EmpTypeEdit.vue?vue&type=template&id=d10259d0"
import script from "./EmpTypeEdit.vue?vue&type=script&lang=js"
export * from "./EmpTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports